import React, { useLayoutEffect } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { logout } from 'app/shared/reducers/authentication';
import { useNavigate } from 'react-router-dom';

export const Logout = () => {
  const logoutUrl = useAppSelector(state => state.authentication.logoutUrl);
  const isLogout = useAppSelector(state => state.authentication.showModalLogin);

  const dispatch = useAppDispatch();

  useLayoutEffect(() => {
    dispatch(logout());
    if (isLogout) {
      window.location.href = '/';
      // navigate("/login",{replace:true})
    }
    // if (isLogout) {
    //   window.location.href = logoutUrl;
    //   navigate("/login",{replace:true})
    // }
  });

  return null;
};

export default Logout;
